import {priceComponentTypes} from "./OCPITariffHelper";
let tariffElements;

const validate = (form, nameFieldsIds, isEmpTariff) => {
    if (typeof isEmpTariff === 'undefined') {
        isEmpTariff = false;
    }
    let elements = [];
    let i = 0;
    for (let type of priceComponentTypes) {
        let priceComponent = [];
        const ac_price = form.form('get value', `ac_${type}`) === "" ? 0 : form.form('get value', `ac_${type}`);
        const dc_price = form.form('get value', `dc_${type}`) === "" ? 0 : form.form('get value', `dc_${type}`);
        if (ac_price !== 0 || dc_price !== 0) {
            priceComponent[0] = {
                type: type.toUpperCase(),
                price: ac_price,
                dc_price: dc_price,
                step_size: 0
            };
            if (isEmpTariff && type.toUpperCase() === 'TIME') {
                const acFreeMinutesFormValue = form.form('get value', 'ac_free_minutes')
                const acFreeMinutes = acFreeMinutesFormValue === "" ? 0 : acFreeMinutesFormValue;
                const dcFreeMinutesFormValue = form.form('get value', 'dc_free_minutes')
                const dcFreeMinutes = dcFreeMinutesFormValue === "" ? 0 : dcFreeMinutesFormValue;
                priceComponent[0].ac_free_minutes = acFreeMinutes;
                priceComponent[0].dc_free_minutes = dcFreeMinutes;
            }
            elements[i] = {
                "price_components": priceComponent
            };
            i++;
        }
    }
    if (elements.length === 0) {
        return false;
    }

    tariffElements = elements;
    const nameField = [];
    for (let i = 0; i < nameFieldsIds.length; i++) {
        let id = nameFieldsIds[i];
        let textFieldName = "tariffName"+id+"[text]";
        let langFieldName = "tariffName"+id+"[language]";
        let textFieldValue = form.form('get value', textFieldName);
        let langFieldValue = form.form('get value', langFieldName);
        form.form({
            fields: {
                textFieldName: {
                    identifier: textFieldName,
                    rules: [
                        {
                            type: 'empty',
                            prompt: 'Tariff name should not be empty'
                        }
                    ]
                }
            }
        });
        form.form('validate form');
        if (!form.form('is valid')) {
            return false;
        } else {
            nameField.push({"language": langFieldValue, "text": textFieldValue});
        }
    }
    return form.form('is valid');
};

export {
    validate,
    tariffElements
}